import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import SiteHeader from '../Site/SiteHeader.js';
import PoetBio from './PoetBio.js';
import SiteFooter from '../Site/SiteFooter.js';
import fixPoetName from '../../helpers/fixPoetName.js';



class Poet extends Component {

  componentWillMount() {
    const {poet} = this.props.match.params;
    this.props.fetchPoet(poet);
    this.props.fetchUser();

    const poetName = fixPoetName(poet);

    document.title = poetName + ' | Close Reading';
  }

  componentWillUnmount(){
    this.props.unmountPoet();
  }

  render() {
    const poet = this.props.home.poet;
    if(!poet)
      return null;
      
    return (
      <div>
        <SiteHeader logOut = {this.props.logOut} home={this.props.home} fetchUser={this.props.fetchUser} />
        <PoetBio home={this.props.home} poet={poet}/>
        <SiteFooter />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    home: state.home
  };
}

export default connect(mapStateToProps, actions)(Poet);



// WEBPACK FOOTER //
// ./src/components/Poet/Poet.js